/* eslint-disable react-hooks/exhaustive-deps */
import { useState } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";

interface AddTileModalProps {
  modalIsOpen: boolean;
  selectedWorkspace: string;
  toggleModal: () => void;
  addTileFunction: (title: string, url: string) => void;
}

export const AddTileModal = (props: AddTileModalProps) => {
  const [newTileTitle, setNewTileTitle] = useState<string>("");
  const [newTileURL, setNewTileURL] = useState<string>("");

  return (
    <Modal isOpen={props.modalIsOpen} toggle={props.toggleModal}>
      <ModalHeader toggle={props.toggleModal}>Create Tile</ModalHeader>
      <div>
        <ModalBody>
          <div>
            <div
              style={{
                fontSize: "larger",
                paddingBottom: "5px",
              }}
            >
              Please provide Tile details
              <hr></hr>
            </div>
            <div>
              <div>Title</div>
              <input
                type="text"
                className="form-control formSignUpUsername"
                value={newTileTitle}
                onChange={(titleInput) => {
                  setNewTileTitle(titleInput.target.value);
                }}
              />
              <div>URL</div>
              <input
                type="text"
                className="form-control formSignUpUsername"
                value={newTileURL}
                onChange={(URLInput) => {
                  setNewTileURL(URLInput.target.value);
                }}
              />
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <Button
            color="primary"
            disabled={!newTileTitle || !newTileURL || newTileURL.length < 9}
            onClick={() => {
              props.toggleModal();
              props.addTileFunction(newTileTitle, newTileURL);
              setNewTileTitle("");
              setNewTileURL("");
            }}
          >
            Create Tile
          </Button>
          <Button
            color="secondary"
            onClick={() => {
              props.toggleModal();
              setNewTileTitle("");
              setNewTileURL("");
            }}
          >
            Cancel
          </Button>
        </ModalFooter>
      </div>
    </Modal>
  );
};
